var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section2" }, [
    _c("div", { staticClass: "bg" }),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "section2-step-title" }, [
        _c(
          "div",
          { staticClass: "section2-step flex-center" },
          _vm._l(_vm.cardList, function (l, index) {
            return _c("CommonCard", { key: index, attrs: { data: l } })
          }),
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }